import { useContext, useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Store } from "../../Utils/Store"
import { ContactInfo as DefaultContactInfo } from "../../Utils/Data"

function Footer() {
        const { state } = useContext(Store);
        
        // Helper function to normalize phone numbers to array
        const normalizePhoneNumbers = (data) => {
          if (!data) {
            return { contact_phone: [] };
          }
          const normalized = { ...data };
          
          // Handle contact_phone field
          if (normalized.contact_phone === undefined || normalized.contact_phone === null) {
            normalized.contact_phone = [];
          } else if (Array.isArray(normalized.contact_phone)) {
            // Already an array, ensure all items are strings
            normalized.contact_phone = normalized.contact_phone
              .map(p => {
                if (p === null || p === undefined) return null;
                if (typeof p === 'object' && p !== null) {
                  // If it's an object, try to extract a value
                  const values = Object.values(p).filter(v => v && typeof v === 'string');
                  return values.length > 0 ? values[0] : null;
                }
                const str = String(p);
                // Reject if it's "[object Object]"
                if (str === '[object Object]' || str.includes('[object')) {
                  console.warn('Footer normalization: Rejecting invalid phone:', str);
                  return null;
                }
                return str.trim();
              })
              .filter(p => p && p.trim() !== '' && p !== '[object Object]' && !String(p).includes('[object'));
            
            console.log('Footer normalization: After processing array, phones:', normalized.contact_phone);
          } else if (typeof normalized.contact_phone === 'string') {
            try {
              // Try to parse if it's a JSON string
              const parsed = JSON.parse(normalized.contact_phone);
              if (Array.isArray(parsed)) {
                normalized.contact_phone = parsed
                  .map(p => {
                    if (p === null || p === undefined) return null;
                    if (typeof p === 'object' && p !== null && !Array.isArray(p)) {
                      const values = Object.values(p).filter(v => v && typeof v === 'string');
                      return values.length > 0 ? values[0] : null;
                    }
                    const str = String(p).trim();
                    if (str === '[object Object]' || str.includes('[object')) return null;
                    return str;
                  })
                  .filter(p => p && p.trim() !== '' && p !== '[object Object]' && !String(p).includes('[object'));
              } else if (typeof parsed === 'string') {
                normalized.contact_phone = [parsed];
              } else {
                normalized.contact_phone = [];
              }
            } catch (e) {
              // Not JSON, treat as single phone number
              normalized.contact_phone = [normalized.contact_phone];
            }
          } else if (typeof normalized.contact_phone === 'object' && normalized.contact_phone !== null) {
            // If it's an object, try to convert to array
            const values = Object.values(normalized.contact_phone)
              .map(p => {
                if (typeof p === 'string') return p;
                if (typeof p === 'object' && p !== null) {
                  return Object.values(p).find(v => typeof v === 'string');
                }
                return null;
              })
              .filter(p => p && p.trim() !== '');
            normalized.contact_phone = values.length > 0 ? values : [];
          } else {
            normalized.contact_phone = [];
          }
          
          // Final safety check - ensure it's an array of strings
          if (!Array.isArray(normalized.contact_phone)) {
            normalized.contact_phone = [];
          }
          
          // If normalization removed all phones, use default
          if (normalized.contact_phone.length === 0 && DefaultContactInfo.contact_phone) {
            normalized.contact_phone = Array.isArray(DefaultContactInfo.contact_phone) 
              ? DefaultContactInfo.contact_phone 
              : [DefaultContactInfo.contact_phone];
          }
          
          return normalized;
        };
        
        const [contactInfo, setContactInfo] = useState(() => {
          const initial = state?.ContactInfo || DefaultContactInfo;
          const normalized = normalizePhoneNumbers(initial);
          // Ensure we always have at least the default phone
          if (!normalized.contact_phone || normalized.contact_phone.length === 0) {
            normalized.contact_phone = Array.isArray(DefaultContactInfo.contact_phone) 
              ? DefaultContactInfo.contact_phone 
              : [DefaultContactInfo.contact_phone];
          }
          return normalized;
        });

        // Fetch contact info from backend and listen to Store updates
        useEffect(() => {
          // Use Store data if available
          if (state?.ContactInfo) {
            const normalized = normalizePhoneNumbers(state.ContactInfo);
            if (!normalized.contact_phone || normalized.contact_phone.length === 0) {
              normalized.contact_phone = Array.isArray(DefaultContactInfo.contact_phone) 
                ? DefaultContactInfo.contact_phone 
                : [DefaultContactInfo.contact_phone];
            }
            setContactInfo(normalized)
          }
          
          // No need to fetch - use Store data
          
          // Listen for storage events to update when admin changes data
          const handleStorageChange = () => {
            const stored = localStorage.getItem('ContactInfo')
            if (stored) {
              try {
                const parsed = JSON.parse(stored);
                setContactInfo(normalizePhoneNumbers(parsed))
              } catch (e) {
                console.error('Error parsing stored contact info:', e)
              }
            }
          }
          
          window.addEventListener('storage', handleStorageChange)
          
          return () => {
            window.removeEventListener('storage', handleStorageChange)
          }
        }, [state?.ContactInfo])
        
        // Update when Store changes
        useEffect(() => {
          if (state?.ContactInfo) {
            const normalized = normalizePhoneNumbers(state.ContactInfo);
            setContactInfo(normalized);
          }
        }, [state?.ContactInfo])
    return (

        <>
        <div id="footer-wrapper" className="footer-dark">
  <footer id="footer">
    <div className="container">
      <div className="row">
        <ul className="col-md-3 col-sm-6 footer-widget-container clearfix">
          {/* .widget.widget_text */}
          <li className="widget widget_newsletterwidget">
            <div className="title">
              <h3>newsletter subscribe</h3>
            </div>
            <p>
              Subscribe to our newsletter and stay updated with our latest 
              transportation services, fleet updates, and special offers across UAE.
            </p>
            <br />
            <form className="newsletter">
              <input
                className="email"
                type="email"
                placeholder="Your email..."
              />
              <input type="submit" className="submit" defaultValue="" />
            </form>
          </li>
          {/* .widget.widget_newsletterwidget end */}
        </ul>
        {/* .col-md-3.footer-widget-container end */}
        <ul className="col-md-3 col-sm-6 footer-widget-container">
          {/* .widget-pages start */}
          <li className="widget widget_pages">
            <div className="title">
              <h3>quick links</h3>
            </div>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/services-overview">Services Overview</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/chiller-ven">Chiller Hiace Van</Link>
              </li>
              <li>
                <Link to="/Freezer-ven">Freezer Hiace Van</Link>
              </li>
              <li>
                <Link to="/flat-bed-details">Trailer Services</Link>
              </li>
            </ul>
          </li>
          {/* .widget-pages end */}
        </ul>
        {/* .col-md-3.footer-widget-container end */}
        <ul className="col-md-3 col-sm-6 footer-widget-container">
          {/* .widget-pages start */}
          <li className="widget widget_pages">
            <div className="title">
              <h3>Industry solutions</h3>
            </div>
            <ul>
              <li>
                <Link to="/services-overview">Chiller</Link>
              </li>
              <li>
                <Link to="/services-overview">Freezer</Link>
              </li>
              <li>
                <Link to="/services-overview">Trailer</Link>
              </li>
            </ul>
          </li>
          {/* .widget-pages end */}
        </ul>
        {/* .col-md-3.footer-widget-container end */}
        <ul className="col-md-3 col-sm-6 footer-widget-container">
          <li className="widget widget-text">
            <div className="title">
              <h3>contact us</h3>
            </div>
            <address>
                                                    {contactInfo.address}<br />
                                                    
            </address>
                                                <div className="text-big">
                                                    {(() => {
                                                        // Defensive extraction of phone numbers
                                                        let phones = [];
                                                        
                                                        // Simple extraction - contact_phone should already be normalized
                                                        if (contactInfo && contactInfo.contact_phone) {
                                                            if (Array.isArray(contactInfo.contact_phone)) {
                                                                phones = contactInfo.contact_phone;
                                                            } else if (typeof contactInfo.contact_phone === 'string') {
                                                                try {
                                                                    const parsed = JSON.parse(contactInfo.contact_phone);
                                                                    phones = Array.isArray(parsed) ? parsed : [parsed];
                                                                } catch (e) {
                                                                    phones = [contactInfo.contact_phone];
                                                                }
                                                            } else if (typeof contactInfo.contact_phone === 'object' && contactInfo.contact_phone !== null) {
                                                                phones = Object.values(contactInfo.contact_phone).filter(p => p);
                                                            }
                                                        }
                                                        
                                                        // Convert all to strings - should already be strings from normalization
                                                        const phoneStrings = phones
                                                            .map(p => {
                                                                if (p === null || p === undefined) return null;
                                                                if (typeof p === 'object' && p !== null) {
                                                                    const values = Object.values(p).filter(v => v && typeof v === 'string');
                                                                    return values.length > 0 ? values[0] : null;
                                                                }
                                                                const str = String(p).trim();
                                                                if (str === '[object Object]' || str.includes('[object')) return null;
                                                                return str;
                                                            })
                                                            .filter(p => p && p.trim() !== '' && p !== '[object Object]');
                                                        
                                                        // If no phones found, use default from Data.jsx
                                                        if (phoneStrings.length === 0) {
                                                            const defaultPhones = Array.isArray(DefaultContactInfo.contact_phone) 
                                                                ? DefaultContactInfo.contact_phone 
                                                                : [DefaultContactInfo.contact_phone];
                                                            return defaultPhones.map((phoneStr, index) => (
                                                                <div key={index} style={{ marginBottom: '5px' }}>
                                                                    <a href={`tel:${String(phoneStr).replace(/\s/g, '')}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                                                                        {String(phoneStr)}
                                                                    </a>
                                                                </div>
                                                            ));
                                                        }
                                                        
                                                        return phoneStrings.map((phoneStr, index) => (
                                                            <div key={index} style={{ marginBottom: '5px' }}>
                                                                <a href={`tel:${phoneStr.replace(/\s/g, '')}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                                                                    {phoneStr}
                                                                </a>
                                                            </div>
                                                        ));
                                                    })()}
                                                </div>
            <br />
            <a href={`mailto:${contactInfo.contact_email}`}>{contactInfo.contact_email}</a>
            <br />
            <ul className="footer-social-icons">
              <li>
                <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer" className="fa fa-facebook" aria-label="Facebook" />
              </li>
              <li>
                <a href={contactInfo.twitter} target="_blank" rel="noopener noreferrer" className="fa fa-twitter" aria-label="Twitter" />
              </li>
              <li>
                <a href={contactInfo.linkedin} target="_blank" rel="noopener noreferrer" className="fa fa-linkedin" aria-label="LinkedIn" />
              </li>
              <li>
                <a href={contactInfo.instagram} target="_blank" rel="noopener noreferrer" className="fa fa-instagram" aria-label="Instagram" />
              </li>
            </ul>
            {/* .footer-social-icons end */}
          </li>
          {/* .widget.widget-text end */}
        </ul>
        {/* .col-md-3.footer-widget-container end */}
      </div>
      {/* .row end */}
    </div>
    {/* .container end */}
  </footer>
  {/* #footer end */}
  <div className="copyright-container">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <p>KD General Transport LLC © {new Date().getFullYear()}. All Rights Reserved.</p>
        </div>
        {/* .col-md-6 end */}
        <div className="col-md-6">
          <p className="align-right">
            Professional Transportation Services Across UAE | <Link to="/admin/login" style={{ color: '#fff', textDecoration: 'none' }}>Admin</Link>
          </p>
        </div>
        {/* .col-md-6 end */}
      </div>
      {/* .row end */}
    </div>
    {/* .container end */}
  </div>
  {/* .copyright-container end */}
</div>

        </>
    )
}

export default Footer